import type { ReactNode } from 'react';
import styled from 'styled-components';

import { IconButton } from '#src/atoms/buttons/IconButton/index.tsx';
import { iconStickyNote } from '#src/atoms/icons/system/iconStickyNote.ts';
import { Centered } from '#src/atoms/layout/Centered/index.tsx';

const CenteredTop = styled(Centered)`
  align-items: start;
`;

type Props = {
  transactionsPath: string;
  children: ReactNode;
};

export const CurrencyBalanceHeader = ({
  transactionsPath,
  children,
}: Props) => (
  <CenteredTop
    right={
      <IconButton
        size="small"
        color="quaternary"
        to={transactionsPath}
        icon={iconStickyNote}
      />
    }
  >
    {children}
  </CenteredTop>
);
